import {Component, Inject, Input, OnInit, ViewChild} from '@angular/core';
import * as angular from 'angular';
import {downgradeComponent} from '@angular/upgrade/static';
import {VIEW_DATE_FORMAT} from '../timecards-builder.service';
import {CookieService} from 'ngx-cookie';
import {LOCATION_SERVICE} from '../../shared/upgrade/location.service';
import {DAYS_COUNTER_SERVICE} from '../../shared/upgrade/days-counter.service';
import {ReportsService} from '../reports.service';
import {each, orderBy, reverse, map, filter, reduce, concat, last, find, findIndex, some, differenceWith, isEqual, isEmpty} from 'lodash';
import { DaterangepickerConfig } from 'ng2-daterangepicker';
import {EmployeeFilterComponent} from '../../shared/employee-filter/employee-filter.component';
import {Employee} from '../../settings/model/employee';
import {
	EmployeeEditHistoryDetails,
	EmployeesEditHistoryCacheService
} from '../../core/employee-edit-history-cache.service';
import {EmployeeEditHistoryEntry} from 'resteasytox';
import {EmployeeType} from '../../settings/settings-employees/settings-employees.component';
import {Moment} from 'moment';
import {ApiService} from '../../api/api.service';
import {DaysCountService} from 'app/reports/days-count.service';
import {NyTzMoment} from '../../shared/ny-tz-moment.service';
import {UserService} from '../../shared/user.service';


export interface Period {
	from: number;
	to: number;
};


interface EmployeeAnnualReportDetails {
	billableHours: number;
	regularHours: number;
	afterHours: number;
	nonBillableHours: number;
	workingDays: number;
	daysOff: number;
	avrBillableHours: number;
}
interface EmployeeAnnualReport {
	'id': number;
	'firstName': string;
	'lastName': string;
	'1099': EmployeeAnnualReportDetails;
	'W-2': EmployeeAnnualReportDetails;
}

type AnnualReport = EmployeeAnnualReport[];

export interface EmployeeTypeHistory {
	'W-2': Period[];
	'1099': Period[];
}

@Component({
	selector: 'tt-annual-report',
	templateUrl: 'annual-report.component.html',
	styleUrls: ['annual-report.component.scss']
})
export class AnnualReportComponent implements OnInit {
	// data from ng1 controller
	@Input('initData') initData: any;
	private currentYear: number = this.nyM.create().year();
	public reportDate: string = this.nyM.create('01/01/' + this.currentYear, VIEW_DATE_FORMAT).format(VIEW_DATE_FORMAT) + '-' +  this.nyM.create().subtract(1, 'day').format(VIEW_DATE_FORMAT);
	public displayedDate: string = this.reportDate;
	public years: number[] = [];
	public includeDisabled: boolean = false;

	public weekends: number = null;
	public totalDays: number = null;
	public countedHolidays: number = null;
	public sortField: string[] = ['firstName', 'lastName'];
	public ascSort: boolean = true;
	public selectedYear: number = this.currentYear;
	public summary: AnnualReport = null;
	public selectedEmployeeType: string = 'W-2';

	private employeesPageStateCookieName: string = 'employeesPageState';
	private employees: Employee[] = [];
	private personalReport: boolean = !this.userService.isAdmin();

	@ViewChild(EmployeeFilterComponent)
	private employeeFilterComponent: EmployeeFilterComponent;


	constructor(
		private daterangepickerOptions: DaterangepickerConfig,
		private cookieService: CookieService,
		@Inject(DAYS_COUNTER_SERVICE) private daysCounterServiceNg1: any,
		@Inject(LOCATION_SERVICE) private locationServiceNg1: angular.ILocationService,
		private reportsService: ReportsService,
		private employeeEditHistoryService: EmployeesEditHistoryCacheService,
		private daysCountService: DaysCountService,
		private nyM: NyTzMoment,
		private apiService: ApiService,
		private userService: UserService
	) {
		for (let i: number = this.currentYear;  i >= 2012;  i--) {
			this.years.push(i);
		}

		const dates: string[] = this.parseDate(this.reportDate);

		this.daterangepickerOptions.settings = {
			locale: { format: 'MM/DD/YYYY'},
			ranges: this.generateDateRangePickerRanges(),
			startDate: dates[0],
			endDate: dates[1],
			dateLimit: 0,
			applyClass: 'btn-blue',
			cancelClass: 'btn-white',
			format: 'MM/DD/YYYY',
			opens: 'left',
			alwaysShowCalendars: true,
			showCustomRangeLabel: true
		};
	}

	ngOnInit(): void {
		this.weekends = this.initData['weekends'];
		this.totalDays = this.initData['days'];
		this.countedHolidays = this.initData['holidays'];

		if (this.userService.user.admin) {
			this.apiService.getAllEmployees({params: {includeDisabled: true}})
				.take(1)
				.subscribe((employees: Employee[]) => {
					this.employees = orderBy(employees, ['firstName']);
				});
		} else {
			this.apiService.getEmployees({params: {employees: [this.userService.user.id]}})
				.take(1)
				.subscribe((employees: Employee[]) => {
					this.employees = employees;
					this.adjustData();
				});
		}
	}

	public onEmployeeFilterInited(): void {
		this.adjustData();
	}

	public updateAnnualReport(date: string): void {
		const self: AnnualReportComponent = this;
		this.reportDate = date;
		const dates: string[] = this.parseDate(date);
		// daysCounterService.updateDaysOff(dates[0],dates[1], function() {
		//     adjustData();
		// });
		this.daysCounterServiceNg1.updateDaysOff(dates[0], dates[1])
			.then(() => {
				self.adjustData();
			});
	};

	public updateReport(year: number, includeDisabled: boolean): void {
		const self: AnnualReportComponent = this;
		if (year) {
			this.selectedYear = year;
			if (this.currentYear === year) {
				this.reportDate = '01/01/' + year + '-' + this.nyM.create().subtract(1, 'day').format(VIEW_DATE_FORMAT);
			} else {
				this.reportDate = '01/01/' + year + '-12/31/' + year;
			}
		}
		this.includeDisabled = includeDisabled;

		this.daysCounterServiceNg1.updateDaysOff('01/01/' + this.selectedYear, '12/31/' + this.selectedYear)
			.then(() => {
				self.adjustData();
			});
	};
	//
	// public changeEmployeeType(employeeType: string): void {
	// 	this.selectedEmployeeType = employeeType;
	// }

	public goToWorkingHoursReport(reportType: string, employeeId: number): void {
		if (this.personalReport) { return; }
		const dates: string[] = this.parseDate(this.reportDate);
		const reportsOptions: any = {
			regularHours: {
				showAfterTime: false,
				showRegularTime: true,
				showNonBillable: false,
				showBillableTime: true
			},
			afterHours: {
				showAfterTime: true,
				showRegularTime: false,
				showNonBillable: false,
				showBillableTime: true
			},
			nonBillableHours: {
				showAfterTime: false,
				showRegularTime: false,
				showNonBillable: true,
				showBillableTime: false
			},
			workingHours: {
				showAfterTime: false,
				showRegularTime: false,
				showNonBillable: false,
				showBillableTime: true
			},
			billable: {
				showAfterTime: false,
				showRegularTime: false,
				showNonBillable: false,
				showBillableTime: true
			},
			daysOff: {
				showAfterTime: false,
				showRegularTime: false,
				showNonBillable: false,
				showBillableTime: false,
				billingCodes: [436]
			}
		};
		const cookieStateData: any = {
			startDate: dates[0],
			endDate: dates[1],
			employees: [employeeId],
			showNonBillable: reportsOptions[reportType].showNonBillable,
			showBillableTime: reportsOptions[reportType].showBillableTime,
			showRegularTime: reportsOptions[reportType].showRegularTime,
			showAfterTime: reportsOptions[reportType].showAfterTime
		};
		if (reportsOptions[reportType].billingCodes) {
			cookieStateData['billingCodes'] = reportsOptions[reportType].billingCodes;
		}

		this.cookieService.putObject('workingHoursState', cookieStateData, {
			expires: new Date(Date.now() + 90 * 24 * 60 * 60 * 1000)
		});

		this.locationServiceNg1.path('/workingHoursReport');
	}

	public goToEmployeePage(employeeId: number): void {
		if (this.personalReport) { return; }
		const data: any = {employeeId: employeeId};
		this.cookieService.putObject(this.employeesPageStateCookieName, data);
		this.locationServiceNg1.path('/settings/employees');
	};

	public employeeFilterChanged(employees: number[]): void {
		this.adjustData();
	}

	public getOrderedSummary(): any[] {
		// return orderBy(this.summary, this.sortField, (this.ascSort) ? ['asc'] : ['desc']);
		// let employee: Employee;
		return orderBy(this.summary, (employee: any) => {
			if (isEqual(this.sortField, ['firstName', 'lastName'])) {
				return this.getEmployeeFirstLastName(employee.id);
			} else {
				return employee[this.selectedEmployeeType][this.sortField[0]];
			}
		}, (this.ascSort) ? ['asc'] : ['desc']);
	}

	public changeEmployeeTypeFilter(filter: string): void {
		this.selectedEmployeeType = filter;

	}

	public getEmployeeFirstLastName(employeeId: number): string {
		const employee: Employee = find(this.employees, {id: employeeId});
		if (employee) {
			return `${employee.firstName} ${employee.lastName}`;
		}
		return '';
	}

	private parseDate(date: string): string[] {
		const r: RegExp = /\s+/gim;
		const dates: string = date.replace(r, '');

		return dates.split('-');
	}

	private formatDates(dates: string[]): string[] {
		const result: string[] = [];
		for (let i: number = 0; i < dates.length; i++) {
			result.push(this.nyM.create(dates[i], VIEW_DATE_FORMAT).format('YYYY-MM-DD'));
		}
		return result;
	}

	private adjustData(): void {
		this.displayedDate = this.reportDate;
		const dates: string[] = this.parseDate(this.reportDate);
		let employees: number[] = (this.personalReport) ? [this.userService.user.id] : this.employeeFilterComponent.getSelectedEmployeesIds();
		if (employees.length === 0) {
			employees = this.employeeFilterComponent.getDisplayedEmployeesIds();
		}

		this.weekends = this.daysCountService.countWeekendsInRange(this.nyM.create(dates[0], VIEW_DATE_FORMAT).valueOf(), this.nyM.create(dates[1], VIEW_DATE_FORMAT).valueOf());
		this.totalDays = this.daysCountService.countDaysInRange(this.nyM.create(dates[0], VIEW_DATE_FORMAT).valueOf(), this.nyM.create(dates[1], VIEW_DATE_FORMAT).valueOf());
		this.countedHolidays = this.daysCounterServiceNg1.countHolidaysInRange(this.nyM.create(dates[0], VIEW_DATE_FORMAT).format(VIEW_DATE_FORMAT), this.nyM.create(dates[1], VIEW_DATE_FORMAT).format(VIEW_DATE_FORMAT));

		// split report period into smaller ones
		// if employee had different employeeTypes winthin report period
		let t: any;
		let periods: any[] = map(employees, (employeeId: number) => {
			t = this.getEmployeeTypeHistory(employeeId, this.nyM.create(dates[0], VIEW_DATE_FORMAT).valueOf(), this.nyM.create(dates[1], VIEW_DATE_FORMAT).valueOf());
			t['employees'] = [employeeId];
			return t;
		});

		// merge periods with same employeeType and duration
		// to decrease amount of database requests
		periods = this.mergeSamePeriods(periods);

		this.reportsService.getAnnualReportByEmployeeType({periods: periods})
			.subscribe((res: any) => {
				this.summary = this.formatAnnualReportNew(res);
			});
	}

	public periodChanged(event: any): void {
		this.reportDate = `${event.start.format(VIEW_DATE_FORMAT)} - ${event.end.format(VIEW_DATE_FORMAT)}`;
	}

	private mergeSamePeriods(periods: any[]): any[] {
		return reduce(periods, (sum: any[], value: any) => {
			const index: number = findIndex(sum, (val: any) => {
				return isEmpty(differenceWith(val['W-2'], value['W-2'], isEqual)) && isEmpty(differenceWith(value['W-2'], val['W-2'], isEqual)) &&
					isEmpty(differenceWith(val['1099'], value['1099'], isEqual)) && isEmpty(differenceWith(value['1099'], val['1099'], isEqual));
			});

			if (index > -1) {
				sum[index]['employees'] = concat(sum[index]['employees'], value['employees']);
			} else {
				sum.push(value);
			}

			return sum;

		}, []);
	}

	private getEmployeeTypeHistory(employeeId: number, from: number, to: number): EmployeeTypeHistory  {
		const payStatusHistory: EmployeeEditHistoryEntry[] = this.employeeEditHistoryService.getEmployeeEntriesForPeriod(employeeId, from, to);
		const history: EmployeeTypeHistory = {'W-2': [], '1099': []};
		let type: 'W-2'|'1099';
		let employeeType: EmployeeType;
		let employeeDetails: EmployeeEditHistoryDetails;
		let f: number, t: number;
		each(reverse(payStatusHistory), (entry: EmployeeEditHistoryEntry) => {
			if (entry.employeeType === null) {
				employeeDetails = this.employeeEditHistoryService.getEmployeeDetailsAtDate(employeeId, entry.startDate);
				employeeType = employeeDetails.employeeType;
			} else {
				employeeType = entry.employeeType;
			}
			if (employeeType === EmployeeType.HOURLY_W2 || employeeType === EmployeeType.DAILY_W2) {
				type = 'W-2';
			} else if (employeeType === EmployeeType.HOURLY_1099 || employeeType === EmployeeType.DAILY_1099) {
				type = '1099';
			}

			f = (entry.startDate >= from) ? entry.startDate : from;
			t = (entry.endDate && entry.endDate <= to) ? entry.endDate : to;

			history[type].push({
				from: f,
				to: t
			});
		});

		return history;

	}

	private formatAnnualReportNew(data: any): AnnualReport {
		const result: AnnualReport = [];

		let emp: EmployeeAnnualReport;
		each(data, (item: any) => {
			each(item.employees, (employeeId: number) => {
				emp = {} as any;
				emp['id'] = employeeId;

				emp['W-2'] = this.formatEmployeeDetails(employeeId, item['W-2']);
				emp['1099'] = this.formatEmployeeDetails(employeeId, item['1099']);

				result.push(emp);
			});
		});

		return result;
	}


	private formatEmployeeDetails(employeeId: number, data: any): EmployeeAnnualReportDetails {
		let result: EmployeeAnnualReportDetails = {} as EmployeeAnnualReportDetails;
		const employeeData: EmployeeAnnualReportDetails[] = reduce(data, (sum: any[], value: any) => {
			return concat(sum, filter(value.data, {id: employeeId}));
		}, []);

		result = reduce(employeeData, (sum: any, value: EmployeeAnnualReportDetails) => {
			return {
				billableHours: sum.billableHours + value.billableHours,
				regularHours: sum.regularHours + value.regularHours,
				afterHours: sum.afterHours + value.afterHours,
				nonBillableHours: sum.nonBillableHours + value.nonBillableHours,
				daysOff: sum.daysOff + value.daysOff
			};
		}, {
			billableHours: 0,
			regularHours: 0,
			afterHours: 0,
			nonBillableHours: 0,
			daysOff: 0
		});
		// convert daysOff hours into days
		result['daysOff'] = result['daysOff'] / 8;

		result['workingDays'] = reduce(data, (sum: number, value: any) => {
				return sum + this.countWorkingDaysForEmployee(employeeId, value.from, value.to);
			}, 0) - result['daysOff'];

		result['avrBillingHours'] = (result['billableHours'] / result['workingDays']) || 0;

		return result;
	}

	private countWorkingDaysForEmployee(employeeId: number, from: number, to: number): number {
		// TODO: Created service to countWorkingDaysForEmployee days off;
		// const daysOff: number =
		const employeeHistoryDetails: EmployeeEditHistoryEntry[] = this.employeeEditHistoryService.getEmployeeEditHistory(employeeId);
		const employeeStartWork: Moment = this.nyM.create(employeeHistoryDetails[0].startDate, VIEW_DATE_FORMAT);
		const employeeEndWork: Moment = (last(employeeHistoryDetails).endDate) ? this.nyM.create(last(employeeHistoryDetails).endDate, VIEW_DATE_FORMAT) : null;

		const periodStart: Moment = (employeeStartWork.isAfter(this.nyM.create(from))) ? employeeStartWork : this.nyM.create(from);
		const periodEnd: Moment = (employeeEndWork && employeeEndWork.isBefore(this.nyM.create(to))) ? employeeEndWork : this.nyM.create(to);


		const totalDays: number = this.daysCountService.countDaysInRange(periodStart.valueOf(), periodEnd.valueOf());
		const holidays: number =  this.daysCounterServiceNg1.countHolidaysInRange(periodStart.format(VIEW_DATE_FORMAT), periodEnd.format(VIEW_DATE_FORMAT));
		const weekends: number = this.daysCountService.countWeekendsInRange(periodStart.valueOf(), periodEnd.valueOf());

		return totalDays - holidays - weekends;
	}

	private generateDateRangePickerRanges(): any {
		const ranges: any = {};

		ranges['Last 30 Days'] = [this.nyM.create().subtract('days', 29), this.nyM.create()];
		ranges['Last Calendar Month'] = [this.nyM.create().subtract(1, 'month').startOf('month'), this.nyM.create().subtract(1, 'month').endOf('month')];
		ranges['Year to Date'] = [this.nyM.create().startOf('year'), this.nyM.create()];
		ranges['Last Calendar Year'] = [this.nyM.create().subtract('year', 1).startOf('year'), this.nyM.create().subtract('year', 1).endOf('year') ];
		ranges['Last Quarter'] = [this.nyM.create().startOf('year').quarter(this.nyM.create().quarter()), this.nyM.create().startOf('year').quarter((this.nyM.create().quarter() % 4) + 1).subtract('days', 1)];

		return ranges;
	}

}


angular.module('timetracker2')
	.directive(
		'ttAnnualReport',
		downgradeComponent({ component: AnnualReportComponent }) as angular.IDirectiveFactory
	);



// WEBPACK FOOTER //
// ./src/app/reports/annual-report/annual-report.component.ts